<template>
  <div 
    class="silvia-embed-wrapper" 
    :class="{ 'menu-expanded': !isMenuCollapsed }"
  >
    <iframe
      ref="iframeRef"
      class="silvia-embed"
      :src="embedUrl"
      frameborder="0"
      allow="clipboard-write; microphone"
    />
  </div>
</template>

<script>
import UserService from '@/service/user/user'
export default {
  name: "Silvia",
  data() {
    return {
      embedUrl: process.env.VUE_APP_SILVIA_EMBED_URL ,
      isSilviaAuthorized: false,
      SILVIA_ORIGIN: process.env.VUE_APP_SILVIA_ORIGIN,
      lastKeepAlive: 0,
    };
  },

  computed: {
    isMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },

    currentSkin() {
      if (document.body.classList.contains('dark-layout')) return 'dark';
      
      const localSkin = localStorage.getItem('vuexy-skin');
      if (localSkin && localSkin.indexOf('dark') !== -1) return 'dark';
      
      return 'light';
    }
  },

  mounted() {
    this.boundHandler = this.handleMessage.bind(this);
    window.addEventListener("message", this.boundHandler);
    this.observer = new MutationObserver(() => {
      const isDark = document.body.classList.contains('dark-layout');
      const newTheme = isDark ? 'dark' : 'light';
      this.updateSilviaTheme(newTheme);
    });

    this.observer.observe(document.body, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
  },

  beforeDestroy() {
    window.removeEventListener("message", this.boundHandler);
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    normalizeTheme(skin) {
      if (skin && (skin === 'dark' || skin.indexOf('dark') !== -1)) {
        return 'dark';
      }
      return 'light';
    },

    sendInitialAuth(skin) {
      const theme = this.normalizeTheme(skin);

      if (!this.$refs.iframeRef || !this.$refs.iframeRef.contentWindow) return;

      const token = sessionStorage.getItem("token");
      const user = this.$store.state.user?.data;
      const permissions = user?.profile?.permissions || [];
      const userId = user?.id;

      if (!token || !user) return;

      const payload = {
        token: token,
        permissions: permissions,
        id: userId,
        user: user,
        theme: theme,
      };

      this.$refs.iframeRef.contentWindow.postMessage({
        type: "SILVIA_AUTH",
        payload: payload,
      }, this.SILVIA_ORIGIN);
    },

    updateSilviaTheme(skin) {
      const theme = this.normalizeTheme(skin);
      if (!this.isSilviaAuthorized || !this.$refs.iframeRef) return;

      this.$refs.iframeRef.contentWindow.postMessage({
        type: "SILVIA_THEME",
        payload: { theme: theme }
      }, this.SILVIA_ORIGIN);
    },

    handleMessage(event) {
      if (event.origin !== this.SILVIA_ORIGIN) return;

      const data = event.data;
      if (!data || !data.type) return;

      if (data.type === "SILVIA_READY") {
        this.checkUserAndAuth();
      }
      
      if (data.type === "SILVIA_AUTH_ACK") {
        this.isSilviaAuthorized = true;
      }

      if (data.type === "SILVIA_ACTIVITY") {
        this.updateLastInteractionTime();
        const now = Date.now();

        if (now - this.lastKeepAlive > 60 * 1000) {
          this.lastKeepAlive = now;
          UserService.me()
        }
        return;
      }
    },

    async checkUserAndAuth() {
      const user = this.$store.state.user?.data;
      if (!user) {
        try {
          await this.$store.dispatch("user/fetch");
        } catch (e) {
          console.error("Portal: Falha ao carregar perfil", e);
        }
      }
      this.sendInitialAuth(this.currentSkin);
    }
  }
};
</script>

<style scoped>
.silvia-embed-wrapper {
  position: fixed;
  top: 0;
  left: 80px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: transparent;
  transition: left 0.3s ease; 
}

.silvia-embed-wrapper.menu-expanded {
  left: 260px; 
}

.silvia-embed {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>